/* Shared validation for the existing Shopify cart handoff. No payment engine here. */
(()=>{
  'use strict';
  const storageKey='azabache-checkout-review';
  function parse(value){
    try{
      const url=new URL(value);
      if(url.protocol!=='https:'||url.hostname!=='azabache-producciones.com'||url.port||url.username||url.password)return null;
      if(!/^\/cart\/[1-9]\d*:[1-9]\d*(,[1-9]\d*:[1-9]\d*)*$/.test(url.pathname))return null;
      const lines=url.pathname.slice('/cart/'.length).split(',').map(line=>{const[id,quantity]=line.split(':');return{id,quantity:Number(quantity)}});
      if(lines.some(line=>!Number.isSafeInteger(line.quantity)))return null;
      return {url,lines};
    }catch{return null}
  }
  function save(data){if(!parse(data.url))return false;try{sessionStorage.setItem(storageKey,JSON.stringify(data));return true}catch{return false}}
  function read(){try{const data=JSON.parse(sessionStorage.getItem(storageKey));return data&&parse(data.url)?data:null}catch{return null}}
  function clear(){try{sessionStorage.removeItem(storageKey)}catch{}}
  window.azCartContract=Object.freeze({parse,save,read,clear});
})();
